<script lang="ts">
    import { capturePHEvent } from "../../../lib/posthog";
  import { modalOpen } from "../../store";
  import Collapsible from "./components/Collapsable.svelte";
  import Logo from "./components/Logo.svelte";

  export let totalFootprint: number | null;
  export let price: number | null;
  export let header: string | null;
  export let moreInfo: string | null;
  export let howItWorksHeader: string | null;
  export let howItWorks: { emoji: string, header: string, content: string }[] | null;
  export let projectName: string | null = "";
  export let projectLocation: string | null = "";
  export let projectShortLocation: string | null = "";
  export let projectCertification: string | null = "";
  export let projectArea: number;
  export let projectDescription: string | null = "";
  export let projectLink: string | null = "";
  export let projectMapLink: string;

  const closeModal = () => {
    modalOpen.set(false);
  };

  // What is this for? I could not find an element with the ID 'modal'
  const backdropCloseModal = (
    e: Event & {
      currentTarget: EventTarget & Element;
    },
  ) => {
    if ((e.target as EventTarget & Element).id == "pina-app-modal") {
      closeModal();
    }
  };

  let iconProps: any = {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    xmlns: "http://www.w3.org/2000/svg",
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
{#if $modalOpen}
  <div id="pina-app-modal" class="pina-modal" on:click={backdropCloseModal}>
    <div class="pina-modal-container">
      <div class="pina-modal-content">
        <div class="pina-modal-header">
          <div class="h1 modal-title">{header}</div>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <span class="btn-close" aria-label="Close" on:click={closeModal}
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#000"
              ><path
                d="M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z"
              /></svg
            >
          </span>
        </div>
        <div class="pina-modal-body">
          <div class="h3">{howItWorksHeader}</div>
          <div class="pina-modal-collapsible-items">
            {#each howItWorks as item, index}
              <Collapsible onChange={(state) => capturePHEvent(state ? "accordion_opened" : "accordion_closed", {index: index})} emoji={item.emoji} headerText={item.header}>
                <div class="p mt-1 text-muted">
                  {item.content}
                </div>
              </Collapsible>
            {/each}
          </div>

          <div class="project mt-3">
            <div class="description">
              <div class="h3">
                {projectName}
              </div>
              <div class="m-0 text-muted">
                <div class="pina-badge-container mt-2">
                  <span class="badge gray"
                    ><svg {...iconProps} class="mr-1"
                      ><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                      ></path><circle cx="12" cy="10" r="3"></circle></svg
                    >
                    {projectLocation}</span
                  >
                  <span class="badge green">
                    <svg {...iconProps} class="mr-1"
                      ><circle cx="12" cy="8" r="7"></circle><polyline
                        points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                      ></polyline></svg
                    >{projectCertification}
                  </span>
                </div>
              </div>
              <div class="p mt-2">{projectDescription}</div>
              <a class="mt-2 button" on:click={() => capturePHEvent("opened_registry_link")} href={projectLink} target="_blank"
                >{moreInfo} ↗︎</a
              >
            </div>
            <img class="map" src={projectMapLink} alt="Map" />
          </div>
        </div>
        <div class="pina-modal-footer">
          powered by <Logo />
        </div>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  $green: #20a243;

  $small-width: 768px;

  .pina-modal {
    position: fixed;
    z-index: 100000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    font-family: "Figtree";
  }

  .pina-modal-container {
    width: 700px;
    margin: 100px auto;

    @media (max-width: $small-width) {
      width: 100vw;
      margin: 0 auto;
    }
  }

  .pina-modal-content {
    background-color: #fefefe;

    border: 1px solid #888;
    border-radius: 10px;
  }

  .pina-modal-header {
    display: flex;
    align-items: top;
    justify-content: space-between;
    padding: 20px 20px;

    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    background-repeat: no-repeat, no-repeat;
    background-position: right, left;
    background-size: cover;
    background-image: url("https://static.climate-app.pina.earth/assets/luckaitztal.webp");

    .modal-title {
      color: #fff !important;
      font-size: 40px;
      margin: 40px 0;
      width: 60%;
      line-height: 1;

      @media (max-width: $small-width) {
        width: 100%;
      }
    }

    .btn-close {
      height: 25px;
      width: 25px;

      display: flex;
      align-items: center;
      justify-content: center;

      background-color: #fff;
      border-radius: 100%;
      padding: 8px;

      &:hover,
      &:focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  .pina-modal-body {
    padding: 15px 20px;

    .h3 {
      font-size: 24px;
    }

    .m-0 {
      margin: 0;
    }

    .mr-1 {
      margin-right: 3px;
    }

    .mt-1 {
      margin-top: 5px;
    }

    .mt-2 {
      margin-top: 15px;
    }

    .mt-3 {
      margin-top: 25px;
    }

    .text-muted {
      color: #888;
    }

    .pina-modal-collapsible-items {
      margin-top: 15px;
    }

    .project {
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: $small-width) {
        display: block;
      }

      .pina-badge-container {
        @media (max-width: $small-width) {
          line-height: 2;
        }
      }

      .description {
        flex: 1;

        svg {
          vertical-align: middle;
          margin-top: -2px;
        }

        .badge {
          color: #fff;
          padding: 3px 7px;
          border-radius: 100px;
          font-size: 13px;
          padding: 6px 12px;
          text-wrap: nowrap;
          border: none;

          &::first {
            margin-right: 10px;
          }

          &.green {
            background: $green;
          }

          &.gray {
            background: #bbb;
          }
        }

        .button {
          display: inline-block;

          padding: 6px 12px;
          min-height: 0;

          font-size: 12px;
          line-height: 1.5;
          color: $green;
          text-decoration: none;

          border: 1px solid $green;
          border-radius: 5px;

          background: transparent;
          transition: background 0.3s;

          &:hover {
            color: #fff;
            background: $green;
            cursor: pointer;
          }

          &::after {
            box-shadow: none;
          }
        }
      }

      .map {
        max-width: 40%;
        border-radius: 10px;

        @media (max-width: $small-width) {
          max-width: 100%;
          margin-top: 20px;
        }
      }
    }
  }

  .pina-modal-footer {
    display: flex;
    justify-content: end;
    gap: 10px;

    padding: 0 20px 15px 20px;

    font-size: 8px;
  }
</style>
